<template>
    <div class="dialog-container">
        <el-dialog
            title="业务延期(延期单位以日计)"
            :visible.sync="visible"
            @close="$emit('update:show', false)"
            :show="show">
            <!-- <span>this is a dialog.</span> -->
            <el-row >
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
        <!-- <span>请检查读卡器</span> -->	
				<el-form-item >
					<el-date-picker type="date" placeholder="延期开始日期" v-model="datetimevalue"></el-date-picker>
				</el-form-item>
                <el-form-item >
					<el-input-number v-model="day" :min="1" :max="20000" placeholder="输入延期天数"></el-input-number>
				</el-form-item>
				<el-form-item >
					<el-input v-model="password" type="password" placeholder="输入操作密码"></el-input>
				</el-form-item>                
				<!-- <el-form-item>
				<el-select  v-model="CoachId" clearable filterable placeholder="选择应用变更的教练">
                 <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
                  </el-option>
                   </el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button  type="primary" v-on:click="PostPone" icon="el-icon-search">确认延期</el-button>
				</el-form-item>																	
			</el-form>	
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import { ComboPostPone} from '../../api/api';

    export default {
        data () {
            return {
                password:'',
                datetimevalue:'',
                day:1,
                visible: this.show
            };
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            msg:{
                type:String,
                default:''
            },
            CardType:{
                type:String,
                default:'',
            }
        },
        watch: {
            show () {
                console.log(this.msg);
                console.log(this.CardType);
                this.day=1;  
                this.datetimevalue='';             
                this.visible = this.show;
                this.password='';
            }
        },
        methods:{
            PostPone(){
                if(this.datetimevalue=='')
                {
                                this.$message({
									message: '请选择延期开始日期',
									type: 'error'
                                });  
                                return false;                  
                }
				let para={
                        startTime:this.datetimevalue,	
                        comboId:this.msg,
                        comboType:this.CardType,
                        day:this.day,
                        passWord:this.password		
				}
              ComboPostPone(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
                                    });
                                    this.visible=false;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '延期出现错误',
					    type: 'error'
					 });	
				});
            }
        }
    };
</script>


// WEBPACK FOOTER //
// Zdialog.vue?4f3c074a